// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* scrollbar */
.ps {
    overflow: hidden !important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
}

.ps__rail-x {
    display: none;
    transition: background-color .2s linear, opacity .2s linear;
    -webkit-transition: background-color .2s linear, opacity .2s linear;
    height: 15px;
    /* there must be 'bottom' or 'top' for ps__rail-x */
    bottom: 0px;
    /* please don't change 'position' */
    position: absolute;
}

.ps__rail-y {
    display: none;
    opacity: 0;
    transition: background-color .2s linear, opacity .2s linear;
    -webkit-transition: background-color .2s linear, opacity .2s linear;
    width: 15px;
    /* there must be 'right' or 'left' for ps__rail-y */
    right: 0;
    /* please don't change 'position' */
    position: absolute;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
    display: block;
    background-color: transparent;
}

.ps__thumb-x {
    background-color: var(--blue-darker);
    border-radius: 6px;
    transition: background-color .2s linear, height .2s ease-in-out;
    -webkit-transition: background-color .2s linear, height .2s ease-in-out;
    height: 6px;
    /* there must be 'bottom' for ps__thumb-x */
    bottom: 2px;
    /* please don't change 'position' */
    position: absolute;
}

.ps__thumb-y {
    background-color: var(--gray-medium);
    border-radius: 6px;
    transition: background-color .2s linear, width .2s ease-in-out;
    -webkit-transition: background-color .2s linear, width .2s ease-in-out;
    width: 6px;
    /* there must be 'right' for ps__thumb-y */
    right: 2px;
    /* please don't change 'position' */
    position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x,
.ps__rail-x.ps--clicking .ps__thumb-x {
    background-color: var(--blue-darker);
    height: 9px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
    background-color: var(--blue-darker);
    height: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
    .ps {
        overflow: auto !important;
    }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .ps {
        overflow: auto !important;
    }
}

.scrollbar-container {
    position: relative;
    height: 100%;
}

/* css */
.heading {
    margin-top: 30px;
    margin-bottom: 30px;
    color: var(--gray-dark);
    font-size: 35px;
    font-weight: 700;
    text-align: center;
}

._2cols {
    display: block;
    margin-bottom: 20px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.col {
    display: flex;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 30px;
    flex-direction: column;
    align-items: center;
}

.heading-2 {
    margin-top: 0px;
    margin-bottom: 0px;
    border-bottom: 1px none var(--off-white);
    color: var(--gray-dark);
    font-size: 30px;
}

.heading-3 {
    margin-top: 0px;
    margin-bottom: 0px;
    color: var(--gray-dark);
    font-size: 35px;
    text-align: center;
}

.hr {
    width: 30%;
    height: 1px;
    margin-top: 15px;
    margin-bottom: 15px;
    background-color: var(--gray-lightest);
}

.subscriptionwrap {
    position: relative;
    width: 320px;
    margin-top: 20px;
    margin-left: 10px;
    margin-right: 10px;
}

.hor-scroll {
    position: static;
    display: block;
    overflow: visible;
    width: 100%;
    height: 100px;
    margin-top: auto;
    margin-bottom: auto;
    padding-right: 11px;
    justify-content: center;
}

.div-block-55 {
    position: relative;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 15;
    overflow: auto;
    width: 100%;
}

.horscrollbtnwrap {
    position: relative;
    display: flex;
    overflow: hidden;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    height: 95%;
    justify-content: flex-start;
    align-items: center;
}

.gb-buttton {
    position: relative;
    display: flex;
    width: 131px;
    height: 100%;
    padding: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px none var(--blue-darker);
    background-color: transparent;
    color: var(--gray-darkest);
    text-align: center;
    cursor: pointer;
}

.gb-buttton.overlay:hover {
    border-color: var(--blue-darker);
    color: var(--blue-darker);
}

.gb-buttton:focus {
    color: var(--blue-darker);
}

.gb-buttton.active {
    color: var(--gray-darkest);
}

.gb-buttton.overlay {
    color: var(--gray);
}

.div-block-50 {
    width: 100%;
}

.scrollwrap {
    position:relative;
    display: flex;
    flex-direction: row;
}

.arrowleft {
    height: 20px;
    color: #03aef3;
    font-size: 20px;
    cursor: pointer;
    align-self: flex-end;
}

.arrowright {
    height: 20px;
    color: #03aef3;
    font-size: 20px;
    cursor: pointer;
    align-self: flex-end;
}

.text-block-33 {
    display: inline-block;
    font-family: 'Hvd fonts brixslab', sans-serif;

    font-size: 50px;
    font-weight: 700;
}

.text-block-34 {
    display: inline-block;
}

.text-block-35 {
    margin-top: 5px;
    padding: 0px;
    font-size: 12px;
    line-height: 12px;
    font-weight: 200;
}

.text-block-36 {
    display: inline-block;
    font-family: 'Hvd fonts brixslab', sans-serif;

    font-size: 26px;
    font-weight: 700;
}

.text-block-37 {
    display: inline-block;
    font-family: 'Hvd fonts brixslab', sans-serif;

    font-size: 26px;
    font-weight: 700;

    border-style: none !important;
}

.texti {
    width: 400px;
    margin-top: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    color: var(--gray-darkest);
    font-size: 18px;
    line-height: 28px;
    font-weight: 300;
    text-align: center;
}

.insertlink {
    color: var(--blue-darker);
    text-decoration: none;
}

.skilmalar {
    width: 100%;
    margin-top: 25px;
}

.skilmalarformwrap {
    display: flex;
    justify-content: center;
    align-items: center;
}

.skilmalartext {
    height: 100%;
    color: var(--gray-dark);
    font-size: 14px;
}

.text-span {
    color: var(--blue-darker);
    font-weight: 500;
}

.formblockwrapper {
    height: 100%;
    margin-bottom: 0px;
    flex: 0 1 auto;
}

.w-form {
    margin: 0 0 15px;
}

.note {
    margin-top: 5px;
    color: var(--gray-dark);
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 30px;
}

.checkbox-field {
    position: relative;
    width: 100%;
    height: 100%;
}

.w-checkbox {
    display: block;
    margin-bottom: 5px;
    padding-left: 20px;
}

input[type="checkbox"] {
    box-sizing: border-box;
    padding: 0;
}

.checkbox {
    position: absolute;
    left: 8px;
    top: -4px;
    margin-top: 0px;
    margin-left: 0px;
}

.w-checkbox-input {
    margin: 9px 0 0;
    line-height: normal;
}

.kaupabtn {
    width: 154px;
    margin-top: 20px;
    border-radius: 25px;
    background-color: var(--blue-darker);
    font-size: 16px;
    font-weight: 700;
    text-align: center;
}

.w-button {
    display: inline-block;
    padding: 9px 15px;
    color: var(--white);
    border: 0;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
}

.kaupabtn:disabled {
    background-color: var(--gray);
    cursor: auto;
}

.logowrapper {
    position: relative;
    display: flex;
    padding: 1rem 0px;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
}

.stadfestingtopwrap {
    display: flex;
    width: 100%;
    padding: 0px 20px;
    flex-direction: column;
    align-items: center;
}

.stadfestinglogo {
    margin-bottom: 20px;
}

img {
    max-width: 100%;
    vertical-align: middle;
    display: inline-block;
}

.stadfestingheader {
    color: #707070;
    font-size: 30px;
    font-weight: 500;
}

.stadfestingbottomwrap {
    padding: 1rem 20px;
    background-color: #fff;
}

.stadfestingtext {
    margin-bottom: 20px;
    color: #707070;
    font-size: 16px;
    line-height: 17px;
    font-weight: 300;
    text-align: center;
}

.innskrabtn {
    display: block;
    width: 50%;
    margin-top: 20px;
    margin-right: auto;
    margin-left: auto;
    border-radius: 25px;
    background-color: #03aef3;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
}

.btn {
    display: block;
    width: 40%;
    margin-top: 20px;
    border-radius: 25px;
    background-color: #03aef3;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
}

.btnYes {
    float: right;
}

.btnNo {
    float: left;
    background-color: #707070;
}

.styles_closeButton__20ID4 {
    cursor: pointer;
}

.styles_modal__gNwvD {
    max-width: 500px !important;
}

@media (max-width: 991px) {
    ._2cols {
        flex-direction: column;
    }

    .col {
        width: 100%;
    }
}

@media (max-width: 479px) {
    .heading {
        margin-bottom: 20px;
        font-size: 30px;
        line-height: 31px;
    }

    .heading-2 {
        width: 100%;
        font-size: 25px;
        text-align: center;
    }

    .heading-3 {
        font-size: 30px;
    }

    .note {
        font-size: 14px;
    }

    .hr {
        width: 90%;
    }

    .texti {
        width: 90%;
        font-size: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/utgardur/Layout/Layout.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,mEAAmE;IACnE,YAAY;IACZ,mDAAmD;IACnD,WAAW;IACX,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,2DAA2D;IAC3D,mEAAmE;IACnE,WAAW;IACX,mDAAmD;IACnD,QAAQ;IACR,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,+DAA+D;IAC/D,uEAAuE;IACvE,WAAW;IACX,2CAA2C;IAC3C,WAAW;IACX,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,8DAA8D;IAC9D,sEAAsE;IACtE,UAAU;IACV,0CAA0C;IAC1C,UAAU;IACV,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;;;IAGI,oCAAoC;IACpC,WAAW;AACf;;AAEA;;;IAGI,oCAAoC;IACpC,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA,QAAQ;AACR;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IAKnB,sBAAsB;IAItB,8BAA8B;IAI9B,mBAAmB;AACvB;;AAEA;IAII,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IAKnB,sBAAsB;IAItB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IAInB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;IACV,WAAW;IACX,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,kBAAkB;IAIlB,aAAa;IACb,gBAAgB;IAChB,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;IAClB,WAAW;IAIX,2BAA2B;IAI3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAIlB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,aAAa;IAKb,sBAAsB;IAItB,uBAAuB;IAIvB,mBAAmB;IACnB,mCAAmC;IACnC,6BAA6B;IAC7B,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;;IAE7C,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;;IAE7C,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;;IAE7C,eAAe;IACf,gBAAgB;;IAEhB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IAII,aAAa;IAIb,uBAAuB;IAIvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAIlB,cAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAIlB,aAAa;IACb,iBAAiB;IAKjB,sBAAsB;IAItB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IAII,aAAa;IACb,WAAW;IACX,iBAAiB;IAKjB,sBAAsB;IAItB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;QAKI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ","sourcesContent":["/* scrollbar */\n.ps {\n    overflow: hidden !important;\n    overflow-anchor: none;\n    -ms-overflow-style: none;\n    touch-action: auto;\n    -ms-touch-action: auto;\n}\n\n.ps__rail-x {\n    display: none;\n    transition: background-color .2s linear, opacity .2s linear;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    height: 15px;\n    /* there must be 'bottom' or 'top' for ps__rail-x */\n    bottom: 0px;\n    /* please don't change 'position' */\n    position: absolute;\n}\n\n.ps__rail-y {\n    display: none;\n    opacity: 0;\n    transition: background-color .2s linear, opacity .2s linear;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    width: 15px;\n    /* there must be 'right' or 'left' for ps__rail-y */\n    right: 0;\n    /* please don't change 'position' */\n    position: absolute;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n    display: block;\n    background-color: transparent;\n}\n\n.ps__thumb-x {\n    background-color: var(--blue-darker);\n    border-radius: 6px;\n    transition: background-color .2s linear, height .2s ease-in-out;\n    -webkit-transition: background-color .2s linear, height .2s ease-in-out;\n    height: 6px;\n    /* there must be 'bottom' for ps__thumb-x */\n    bottom: 2px;\n    /* please don't change 'position' */\n    position: absolute;\n}\n\n.ps__thumb-y {\n    background-color: var(--gray-medium);\n    border-radius: 6px;\n    transition: background-color .2s linear, width .2s ease-in-out;\n    -webkit-transition: background-color .2s linear, width .2s ease-in-out;\n    width: 6px;\n    /* there must be 'right' for ps__thumb-y */\n    right: 2px;\n    /* please don't change 'position' */\n    position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x,\n.ps__rail-x.ps--clicking .ps__thumb-x {\n    background-color: var(--blue-darker);\n    height: 9px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n    background-color: var(--blue-darker);\n    height: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n    .ps {\n        overflow: auto !important;\n    }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .ps {\n        overflow: auto !important;\n    }\n}\n\n.scrollbar-container {\n    position: relative;\n    height: 100%;\n}\n\n/* css */\n.heading {\n    margin-top: 30px;\n    margin-bottom: 30px;\n    color: var(--gray-dark);\n    font-size: 35px;\n    font-weight: 700;\n    text-align: center;\n}\n\n._2cols {\n    display: block;\n    margin-bottom: 20px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.col {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    margin-top: 20px;\n    margin-bottom: 30px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.heading-2 {\n    margin-top: 0px;\n    margin-bottom: 0px;\n    border-bottom: 1px none var(--off-white);\n    color: var(--gray-dark);\n    font-size: 30px;\n}\n\n.heading-3 {\n    margin-top: 0px;\n    margin-bottom: 0px;\n    color: var(--gray-dark);\n    font-size: 35px;\n    text-align: center;\n}\n\n.hr {\n    width: 30%;\n    height: 1px;\n    margin-top: 15px;\n    margin-bottom: 15px;\n    background-color: var(--gray-lightest);\n}\n\n.subscriptionwrap {\n    position: relative;\n    width: 320px;\n    margin-top: 20px;\n    margin-left: 10px;\n    margin-right: 10px;\n}\n\n.hor-scroll {\n    position: static;\n    display: block;\n    overflow: visible;\n    width: 100%;\n    height: 100px;\n    margin-top: auto;\n    margin-bottom: auto;\n    padding-right: 11px;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n.div-block-55 {\n    position: relative;\n    left: 0px;\n    top: 0px;\n    right: 0px;\n    bottom: 0px;\n    z-index: 15;\n    overflow: auto;\n    width: 100%;\n}\n\n.horscrollbtnwrap {\n    position: relative;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    overflow: hidden;\n    width: fit-content;\n    height: 95%;\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.gb-buttton {\n    position: relative;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 131px;\n    height: 100%;\n    padding: 20px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    border: 1px none var(--blue-darker);\n    background-color: transparent;\n    color: var(--gray-darkest);\n    text-align: center;\n    cursor: pointer;\n}\n\n.gb-buttton.overlay:hover {\n    border-color: var(--blue-darker);\n    color: var(--blue-darker);\n}\n\n.gb-buttton:focus {\n    color: var(--blue-darker);\n}\n\n.gb-buttton.active {\n    color: var(--gray-darkest);\n}\n\n.gb-buttton.overlay {\n    color: var(--gray);\n}\n\n.div-block-50 {\n    width: 100%;\n}\n\n.scrollwrap {\n    position:relative;\n    display: flex;\n    flex-direction: row;\n}\n\n.arrowleft {\n    height: 20px;\n    color: #03aef3;\n    font-size: 20px;\n    cursor: pointer;\n    align-self: flex-end;\n}\n\n.arrowright {\n    height: 20px;\n    color: #03aef3;\n    font-size: 20px;\n    cursor: pointer;\n    align-self: flex-end;\n}\n\n.text-block-33 {\n    display: inline-block;\n    font-family: 'Hvd fonts brixslab', sans-serif;\n\n    font-size: 50px;\n    font-weight: 700;\n}\n\n.text-block-34 {\n    display: inline-block;\n}\n\n.text-block-35 {\n    margin-top: 5px;\n    padding: 0px;\n    font-size: 12px;\n    line-height: 12px;\n    font-weight: 200;\n}\n\n.text-block-36 {\n    display: inline-block;\n    font-family: 'Hvd fonts brixslab', sans-serif;\n\n    font-size: 26px;\n    font-weight: 700;\n}\n\n.text-block-37 {\n    display: inline-block;\n    font-family: 'Hvd fonts brixslab', sans-serif;\n\n    font-size: 26px;\n    font-weight: 700;\n\n    border-style: none !important;\n}\n\n.texti {\n    width: 400px;\n    margin-top: 10px;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    color: var(--gray-darkest);\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 300;\n    text-align: center;\n}\n\n.insertlink {\n    color: var(--blue-darker);\n    text-decoration: none;\n}\n\n.skilmalar {\n    width: 100%;\n    margin-top: 25px;\n}\n\n.skilmalarformwrap {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.skilmalartext {\n    height: 100%;\n    color: var(--gray-dark);\n    font-size: 14px;\n}\n\n.text-span {\n    color: var(--blue-darker);\n    font-weight: 500;\n}\n\n.formblockwrapper {\n    height: 100%;\n    margin-bottom: 0px;\n    -webkit-box-flex: 0;\n    -webkit-flex: 0 auto;\n    -ms-flex: 0 auto;\n    flex: 0 auto;\n}\n\n.w-form {\n    margin: 0 0 15px;\n}\n\n.note {\n    margin-top: 5px;\n    color: var(--gray-dark);\n    font-size: 16px;\n    font-weight: 700;\n    margin-bottom: 30px;\n}\n\n.checkbox-field {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.w-checkbox {\n    display: block;\n    margin-bottom: 5px;\n    padding-left: 20px;\n}\n\ninput[type=\"checkbox\"] {\n    box-sizing: border-box;\n    padding: 0;\n}\n\n.checkbox {\n    position: absolute;\n    left: 8px;\n    top: -4px;\n    margin-top: 0px;\n    margin-left: 0px;\n}\n\n.w-checkbox-input {\n    margin: 9px 0 0;\n    line-height: normal;\n}\n\n.kaupabtn {\n    width: 154px;\n    margin-top: 20px;\n    border-radius: 25px;\n    background-color: var(--blue-darker);\n    font-size: 16px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.w-button {\n    display: inline-block;\n    padding: 9px 15px;\n    color: var(--white);\n    border: 0;\n    line-height: inherit;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.kaupabtn:disabled {\n    background-color: var(--gray);\n    cursor: auto;\n}\n\n.logowrapper {\n    position: relative;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 1rem 0px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: #fff;\n}\n\n.stadfestingtopwrap {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    padding: 0px 20px;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.stadfestinglogo {\n    margin-bottom: 20px;\n}\n\nimg {\n    max-width: 100%;\n    vertical-align: middle;\n    display: inline-block;\n}\n\n.stadfestingheader {\n    color: #707070;\n    font-size: 30px;\n    font-weight: 500;\n}\n\n.stadfestingbottomwrap {\n    padding: 1rem 20px;\n    background-color: #fff;\n}\n\n.stadfestingtext {\n    margin-bottom: 20px;\n    color: #707070;\n    font-size: 16px;\n    line-height: 17px;\n    font-weight: 300;\n    text-align: center;\n}\n\n.innskrabtn {\n    display: block;\n    width: 50%;\n    margin-top: 20px;\n    margin-right: auto;\n    margin-left: auto;\n    border-radius: 25px;\n    background-color: #03aef3;\n    font-size: 14px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.btn {\n    display: block;\n    width: 40%;\n    margin-top: 20px;\n    border-radius: 25px;\n    background-color: #03aef3;\n    font-size: 14px;\n    font-weight: 700;\n    text-align: center;\n}\n\n.btnYes {\n    float: right;\n}\n\n.btnNo {\n    float: left;\n    background-color: #707070;\n}\n\n.styles_closeButton__20ID4 {\n    cursor: pointer;\n}\n\n.styles_modal__gNwvD {\n    max-width: 500px !important;\n}\n\n@media (max-width: 991px) {\n    ._2cols {\n        -webkit-box-orient: vertical;\n        -webkit-box-direction: normal;\n        -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n        flex-direction: column;\n    }\n\n    .col {\n        width: 100%;\n    }\n}\n\n@media (max-width: 479px) {\n    .heading {\n        margin-bottom: 20px;\n        font-size: 30px;\n        line-height: 31px;\n    }\n\n    .heading-2 {\n        width: 100%;\n        font-size: 25px;\n        text-align: center;\n    }\n\n    .heading-3 {\n        font-size: 30px;\n    }\n\n    .note {\n        font-size: 14px;\n    }\n\n    .hr {\n        width: 90%;\n    }\n\n    .texti {\n        width: 90%;\n        font-size: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
